export default "__VITE_ASSET__26f3614f__"